<div class="auth login">
    <div class="auth__header flex flex-col gap-4 text-center">
      <div class="mail__icon" inlineSVG="auth/sms.svg"></div>
      <h2>Verify Your Email</h2>
      <p>
        Please Enter OTP Which Sent to<br />
        <span [innerText]="verifyEmailService.email"></span>
      </p>
    </div>
  
    <app-verification-code  (onSubmit)="submit($event)" (onResendCode)="resendCode()"></app-verification-code>
  </div>
  